import { createGlobalState, useCallback } from '~libs.ui.react';

import { CurrentPractitioner, CurrentPractitionerGetter, CurrentPractitionerSetter } from './types';

type UseCurrentPractitionerGlobalStateReturnFn = Readonly<{
   getCurrentPractitioner: CurrentPractitionerGetter;
   setCurrentPractitioner: CurrentPractitionerSetter;
}>;

const useGlobalState = createGlobalState<CurrentPractitioner | null>(null);

export const useCurrentPractitionerGlobalState = (): UseCurrentPractitionerGlobalStateReturnFn => {
   const [globalState, setGlobalState] = useGlobalState();

   const getCurrentPractitioner: CurrentPractitionerGetter = useCallback(() => {
      return globalState;
   }, [globalState]);

   const setCurrentPractitioner: CurrentPractitionerSetter = useCallback(
      (currentPractitioner) => {
         return setGlobalState(currentPractitioner);
      },
      [setGlobalState]
   );

   return {
      getCurrentPractitioner: getCurrentPractitioner,
      setCurrentPractitioner: setCurrentPractitioner,
   };
};
